// Mock data for Montifloors — a mobile-showroom flooring company.
// NOTE: This is mock data used for the frontend-only build.

export const business = {
  name: 'Monti Home Pros',
  tagline: 'Your Home, Handled',
  email: 'hello@montihomepros.com',
  emailHref: 'mailto:hello@montihomepros.com',
  phone: '571-331-8224',
  phoneHref: 'tel:+15713318224',
  floorsName: 'Monti Floors',
  serviceArea: 'Northern Virginia',
  since: 2009,
  hours: [
    { day: 'Monday', time: '9:00 AM – 6:00 PM' },
    { day: 'Tuesday', time: '9:00 AM – 6:00 PM' },
    { day: 'Wednesday', time: '9:00 AM – 6:00 PM' },
    { day: 'Thursday', time: '9:00 AM – 6:00 PM' },
    { day: 'Friday', time: '9:00 AM – 6:00 PM' },
    { day: 'Saturday', time: '10:00 AM – 4:00 PM' },
    { day: 'Sunday', time: 'By Appointment' }
  ],
  socials: [
    { name: 'Facebook', href: '#' },
    { name: 'Instagram', href: '#' },
    { name: 'Houzz', href: '#' }
  ]
};

export const heroSlides = [
  {
    id: 1,
    kicker: 'Mobile Flooring Showroom',
    title: 'Here to floor you.',
    subtitle: 'We bring hundreds of premium flooring samples straight to your door — so you can choose in the light of your own home.',
    cta: { label: 'Shop Flooring', to: '/flooring' },
    image: 'https://images.unsplash.com/photo-1560184897-1ee3713708ee?auto=format&fit=crop&w=1920&q=80'
  },
  {
    id: 2,
    kicker: 'Free In-Home Consultation',
    title: 'Here to guide you.',
    subtitle: 'Get a sneak peek at your new floors with expert advice, honest pricing, and measurements at no cost.',
    cta: { label: 'Book a Visit', to: '/estimate' },
    image: 'https://images.unsplash.com/photo-1649083048770-82e8ffd80431?auto=format&fit=crop&w=1920&q=80'
  },
  {
    id: 3,
    kicker: 'Quality You Can Trust',
    title: 'Here to install for you.',
    subtitle: 'From concept to the final board, our experienced installers deliver a finish that lasts for decades.',
    cta: { label: 'See Our Work', to: '/about' },
    image: 'https://images.unsplash.com/photo-1560449752-3fd4bdbe7df0?auto=format&fit=crop&w=1920&q=80'
  }
];

export const categories = [
  {
    slug: 'hardwood',
    name: 'Hardwood',
    short: 'Timeless styles, stains, and finishes—plus water and scratch resistance.',
    image: 'https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80',
    hero: 'https://images.unsplash.com/photo-1560184897-1ee3713708ee?auto=format&fit=crop&w=1920&q=80',
    intro: 'Nothing rivals the warmth and character of genuine hardwood. Choose from oak, maple, hickory, and exotic species in a spectrum of stains and finishes.',
    features: ['Solid & engineered options', 'Refinishable surfaces', 'Adds long-term home value', 'Naturally warm underfoot'],
    brands: ['Shaw', 'Mohawk', 'Bruce', 'Somerset']
  },
  {
    slug: 'carpet',
    name: 'Carpet',
    short: 'The warmth and comfort you know. Innovation and performance you’ll love.',
    image: 'https://images.unsplash.com/photo-1616450088319-ff2ea6e7cc68?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80',
    hero: 'https://images.unsplash.com/photo-1616450088319-ff2ea6e7cc68?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80',
    intro: 'Soft, quiet, and endlessly cozy. Today’s carpets combine plush comfort with stain-fighting fibers built for real, busy homes.',
    features: ['Stain & soil resistance', 'Pet-friendly fibers', 'Sound-dampening comfort', 'Hundreds of colors'],
    brands: ['Mohawk SmartStrand', 'Shaw Caress', 'Karastan', 'Anderson Tuftex']
  },
  {
    slug: 'tile',
    name: 'Tile',
    short: 'Stylish colors, patterns, shapes, and sizes for every project.',
    image: 'https://images.unsplash.com/photo-1708919268837-2b4857323447?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80',
    hero: 'https://images.unsplash.com/photo-1706629503571-c165023a7792?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80',
    intro: 'Porcelain and ceramic tile bring waterproof durability and design flexibility to kitchens, baths, and beyond.',
    features: ['Waterproof & hygienic', 'Endless patterns', 'Great with radiant heat', 'Extremely durable'],
    brands: ['Daltile', 'Marazzi', 'MSI', 'American Olean']
  },
  {
    slug: 'vinyl',
    name: 'Luxury Vinyl',
    short: 'Innovative wood, tile, and stone looks that are beautiful and durable.',
    image: 'https://images.unsplash.com/photo-1604410880766-737427d11b70?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80',
    hero: 'https://images.unsplash.com/photo-1655512318649-8e32533c1c9f?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80',
    intro: '100% waterproof luxury vinyl plank and tile deliver realistic wood and stone visuals with worry-free performance.',
    features: ['100% waterproof', 'Kid & pet proof', 'Easy click install', 'Comfortable underfoot'],
    brands: ['Shaw Floorté', 'Mohawk SolidTech', 'COREtec', 'Karndean']
  },
  {
    slug: 'laminate',
    name: 'Laminate',
    short: 'Low-maintenance durability for high-traffic areas of your home.',
    image: 'https://images.unsplash.com/photo-1585128792020-803d29415281?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80',
    hero: 'https://images.unsplash.com/photo-1585128792020-803d29415281?auto=format&fit=crop&w=1920&q=80',
    intro: 'Modern laminate captures the look of hardwood with a tough wear layer that shrugs off scratches, dents, and daily life.',
    features: ['Scratch resistant', 'Budget friendly', 'Realistic wood looks', 'Fast installation'],
    brands: ['Mohawk RevWood', 'Shaw Repel', 'Pergo', 'Quick-Step']
  },
  {
    slug: 'area-rugs',
    name: 'Area Rugs & Stair Runners',
    short: 'The added comfort you need for your floors and stairs.',
    image: 'https://images.unsplash.com/photo-1671576563965-23993d69eb17?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80',
    hero: 'https://images.unsplash.com/photo-1575204015311-0fe377370780?auto=format&fit=crop&w=1920&q=80',
    intro: 'Finish a room or dress your stairs with custom-bound area rugs and runners crafted from the carpet of your choice.',
    features: ['Custom sizes & binding', 'Stair runner installation', 'Wool & synthetic options', 'Designer patterns'],
    brands: ['Mohawk', 'Shaw', 'Karastan', 'Nourison']
  }
];

export const steps = [
  { id: 1, title: 'Book your visit', text: 'Call or request an appointment online. Pick a time that works for your schedule.' },
  { id: 2, title: 'We come to you', text: 'Your consultant arrives with samples of the exact flooring types you requested, so you can compare them in your own lighting.' },
  { id: 3, title: 'Free measure & quote', text: 'We measure precisely and give you honest, all-in pricing with no surprises.' },
  { id: 4, title: 'Professional install', text: 'Our experienced installers handle everything from removal to the final finished floor.' }
];

export const reasons = [
  { title: 'No showroom overhead', text: 'We pass the savings on to you — premium brands at honest prices.' },
  { title: 'Shop in your own light', text: 'Colors look different at home. See samples exactly where they’ll live.' },
  { title: 'One expert, start to finish', text: 'The same person who guides your choice manages your install.' },
  { title: 'Professional installation', text: 'Every project handled by experienced, background-checked installers.' }
];

export const reviews = [
  { name: 'Mahlon M.', rating: 5, text: 'They rock! Had them come out for two separate projects—both were great. If you meticulously research contractors, just save yourself the time and call them now; they’re the best.' },
  { name: 'Jennifer C.', rating: 5, text: 'Can’t say enough amazing things about Montifloors. High-quality carpet, exceptional customer service, and professional installation all at a great price. I love my new floors!' },
  { name: 'Susan G.', rating: 5, text: 'Having the samples brought to my home made all the difference. My consultant helped me pick a rug that fit my price range and kept me updated the whole way. Wonderful service.' },
  { name: 'David R.', rating: 5, text: 'Transparent, attentive, and genuinely helpful. The in-home consultation took the stress completely out of choosing flooring. Highly recommend.' },
  { name: 'Priya K.', rating: 5, text: 'From measurement to install, the crew was punctual and tidy. Our luxury vinyl looks incredible and handled our kids and dog with ease.' },
  { name: 'Tom & Linda B.', rating: 5, text: 'Fair pricing and no pressure. We compared three companies and Montifloors was by far the easiest to work with. The hardwood is stunning.' }
];

export const faqs = [
  { q: 'Do you have a physical store I can visit?', a: 'We’re a mobile showroom — instead of you driving to us, we bring the samples to you. It saves you time and lets you see every option in your home’s real lighting.' },
  { q: 'What areas do you serve?', a: 'We proudly serve Northern Virginia. If you’re nearby and not sure whether we cover your area, just email us at hello@montifloors.com.' },
  { q: 'Is the consultation really free?', a: 'Yes. Your in-home consultation, sample viewing, measurement, and estimate are all completely free with no obligation.' },
  { q: 'Do you handle installation?', a: 'Absolutely. Our experienced installers handle everything — furniture moving, old floor removal, and a flawless finish.' },
  { q: 'How long does installation take?', a: 'Most residential projects are completed in one to three days depending on the size of the space and the product selected.' }
];


// Promo for sister brand
export const homeServices = {
  title: 'Ask about Monti Floors for your flooring needs',
  blurb: 'A dedicated mobile flooring showroom — part of the Monti Home Pros family.'
};

// Monti Home Pros hero + service divisions
export const hpHero = {
  kicker: 'Monti Home Pros',
  title: 'Your home, handled.',
  subtitle: 'One trusted local team for the repairs, upgrades, and finishing touches that keep your home looking its best — including our dedicated Monti Floors division.',
  image: 'https://images.unsplash.com/photo-1618219908412-a29a1bb7b86e?auto=format&fit=crop&w=1920&q=80'
};

// icon keys map to lucide icons in the component
export const hpServices = [
  { icon: 'Hammer', title: 'Handyman & Repairs', text: 'From squeaky doors to honey-do lists — the small fixes that add up, done right the first time.' },
  { icon: 'PaintRoller', title: 'Interior & Exterior Painting', text: 'Fresh, flawless finishes for a single room or your whole home, inside and out.' },
  { icon: 'Wrench', title: 'Plumbing', text: 'Faucets, fixtures, leaks, and installs handled by tidy, reliable pros.' },
  { icon: 'Zap', title: 'Electrical', text: 'Lighting, outlets, fixtures, and safe upgrades done right.' },
  { icon: 'ChefHat', title: 'Kitchen & Bath Remodeling', text: 'Beautiful, functional renovations managed end to end — on time and on budget.' },
  { icon: 'Ruler', title: 'Drywall & Carpentry', text: 'Patches, trim, built-ins, and custom woodwork with a flawless finish.' },
  { icon: 'Droplets', title: 'Power Washing & Exterior', text: 'Driveways, siding, decks, and walkways restored to like-new curb appeal.' },
  { icon: 'LayoutGrid', title: 'Flooring — Monti Floors', text: 'Our mobile flooring showroom brings premium samples to your door.', to: '/floors' }
];

export const hpSteps = [
  { id: 1, title: 'Tell us what you need', text: 'Send a quick message or call — describe the project, big or small.' },
  { id: 2, title: 'Get a clear quote', text: 'We visit, assess, and give you honest, all-in pricing with no surprises.' },
  { id: 3, title: 'We get to work', text: 'Vetted, background-checked pros show up on time and treat your home with care.' },
  { id: 4, title: 'Love the result', text: 'We don’t finish until you’re thrilled with the work.' }
];

export const hpReasons = [
  { title: 'One call does it all', text: 'Skip juggling contractors — we coordinate every trade under one roof.' },
  { title: 'Vetted local pros', text: 'Background-checked, insured, and experienced teams you can trust.' },
  { title: 'Honest, upfront pricing', text: 'Clear quotes before we start. No surprise fees, ever.' },
  { title: 'Serving Northern Virginia', text: 'Proud to be your neighbors — responsive, reliable, and local.' }
];


// Real flooring sample products sourced from DesignShop catalog.
// Image helper for DesignShop CDN swatches.
const ds = (folder, id) => `https://cdn.designshop.com/DAMRoot/Original/${folder}/${id}.jpg?quality=83&width=600&format=webp`;

// All sub-categories / types available in the US for each floor type.
export const categoryTypes = {
  hardwood: ['Solid Hardwood', 'Engineered Hardwood', 'Wide-Plank', 'Herringbone & Parquet', 'Oak', 'Maple', 'Hickory', 'Walnut', 'Bamboo', 'Hand-Scraped / Distressed'],
  carpet: ['Cut Pile (Plush / Saxony)', 'Frieze / Textured', 'Berber & Level Loop', 'Patterned', 'Carpet Tiles', 'Wool', 'Nylon', 'Polyester (PET)', 'Triexta', 'Stain-Resistant'],
  tile: ['Porcelain', 'Ceramic', 'Natural Stone', 'Marble', 'Granite', 'Travertine', 'Slate', 'Mosaic', 'Cement / Encaustic', 'Terrazzo-Look', 'Wood-Look Tile'],
  vinyl: ['Luxury Vinyl Plank (LVP)', 'Luxury Vinyl Tile (LVT)', 'Rigid Core (SPC)', 'WPC', 'Sheet Vinyl', 'Glue-Down', 'Click / Floating', 'Waterproof', 'Herringbone', 'Stone-Look'],
  laminate: ['AC3 Residential', 'AC4 Heavy Residential', 'AC5 Commercial', 'AC6 Extra Heavy', 'Wide-Plank', 'Water-Resistant', 'High-Gloss', 'Textured / Embossed', 'Herringbone', 'Wood-Species Looks'],
  'area-rugs': ['Hand-Knotted', 'Hand-Tufted', 'Flatweave', 'Wool', 'Natural Fiber (Jute / Sisal)', 'Synthetic', 'Custom-Bound Rugs', 'Stair Runners', 'Hide', 'Machine-Washable']
};

// Real, selectable samples per category (names, brands & colors from DesignShop).
export const categorySamples = {
  hardwood: [
    { name: 'Reflections White Oak', brand: 'Shaw', finish: 'Natural · Engineered', image: ds('10725', '101753144') },
    { name: 'TecWood Select', brand: 'Mohawk', finish: 'Coventry Oak', image: ds('10000', '100212617') },
    { name: 'Expressions Herringbone', brand: 'Shaw', finish: 'Cocoa', image: ds('10683', '101753094') },
    { name: 'Brevanna Oak', brand: 'Karastan (Mohawk)', finish: 'Cobble Path · Engineered', image: ds('10769', '300049424') },
    { name: 'Rare Vintage White Oak', brand: 'Mohawk', finish: 'Prime Grade', image: ds('10352', '101381811') }
  ],
  carpet: [
    { name: 'Balance II', brand: 'Mohawk EverStrand', finish: 'Plush', image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_light-floors/artifacts/zskgmmii_image.png' },
    { name: 'Caress by Anso', brand: 'Shaw', finish: 'Soft Taupe · Cut Pile', image: 'https://images.pexels.com/photos/30458072/pexels-photo-30458072.jpeg?auto=compress&cs=tinysrgb&w=700' },
    { name: 'Air.o Soft', brand: 'Mohawk', finish: 'Dove Gray · Textured', image: 'https://images.unsplash.com/photo-1616450088319-ff2ea6e7cc68?auto=format&fit=crop&w=700&q=80' },
    { name: 'LifeGuard Berber', brand: 'Shaw', finish: 'Sandstone · Level Loop', image: 'https://images.pexels.com/photos/30458072/pexels-photo-30458072.jpeg?auto=compress&cs=tinysrgb&w=700' },
    { name: 'EverStrand Plush', brand: 'Mohawk', finish: 'Almond · Soft', image: 'https://images.unsplash.com/photo-1616450088319-ff2ea6e7cc68?auto=format&fit=crop&w=700&q=80' },
    { name: 'Cherry Way', brand: 'Mohawk EverStrand', finish: 'Textured', image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_light-floors/artifacts/17pv1trz_image.png' }
  ],
  tile: [
    { name: 'Marble Attaché', brand: 'Daltile', finish: 'Azul · Marble', image: ds('10000', '100023886') },
    { name: 'Classentino', brand: 'Marazzi', finish: 'Ocean Blue · Porcelain', image: ds('10001', '100556235') },
    { name: 'Thassos Plaid', brand: 'Daltile', finish: 'Marble Mosaic', image: ds('107', '301037852') },
    { name: 'Onyx Slab', brand: 'MSI', finish: 'Onice Perla', image: ds('10000', '100382608') },
    { name: 'Crater', brand: 'American Olean', finish: 'Gloss Ceramic', image: ds('11442', '300027288') },
    { name: 'Bianco Dolomiti', brand: 'Daltile', finish: 'Marble', image: ds('10000', '100028469') },
    { name: 'Hexagon Mosaic', brand: 'Marazzi', finish: 'Pink Earth · Porcelain', image: ds('10000', '100378880') },
    { name: 'Galaxy Grey', brand: 'MSI', finish: 'Granite', image: ds('10000', '100028452') },
    { name: 'Carrara Drift', brand: 'Daltile', finish: 'Marble Mosaic', image: ds('107', '301037863') }
  ],
  vinyl: [
    { name: 'Floorté Pro', brand: 'Shaw', finish: 'Elk · Wide Plank', image: ds('105', '301047161') },
    { name: 'SolidTech', brand: 'Mohawk', finish: 'Arlo · Rigid Core', image: ds('10478', '100247525') },
    { name: 'Floorté Classic', brand: 'Shaw', finish: 'Sable', image: ds('11067', '102105447') },
    { name: 'SolidTech Plus', brand: 'Mohawk', finish: 'Ashford', image: ds('10000', '100165362') },
    { name: 'Paragon', brand: 'Shaw', finish: 'Palka', image: ds('10000', '100381245') },
    { name: 'SolidTech Select', brand: 'Mohawk', finish: 'Tekapo Oak', image: ds('10000', '100378933') },
    { name: 'Floorté Herringbone', brand: 'Shaw', finish: 'Brenwick', image: ds('11067', '102105449') },
    { name: 'SolidTech', brand: 'Mohawk', finish: 'Beam · Wide Plank', image: ds('105', '301047206') }
  ],
  laminate: [
    { name: 'Emberluxe', brand: 'Karastan (Mohawk)', finish: 'Moonlit Oak', image: ds('10769', '300049398') },
    { name: 'Danbury Alcove', brand: 'Karastan (Mohawk)', finish: 'Rainfall Walnut', image: ds('10769', '300049387') },
    { name: 'RevWood Plus', brand: 'Mohawk', finish: 'Merino Wool Oak', image: ds('10769', '300049370') },
    { name: 'Farrington Crest', brand: 'Karastan (Mohawk)', finish: 'Dove Hickory', image: ds('10769', '300049403') },
    { name: 'RevWood Select', brand: 'Mohawk', finish: 'Charcoal Oak', image: ds('10769', '300049345') },
    { name: 'Repel Laminate', brand: 'Shaw', finish: 'Vintage Tea Oak', image: ds('10769', '300049354') },
    { name: 'Timberline HD', brand: 'Shaw', finish: 'Michigan Clear', image: ds('10000', '100209872') },
    { name: 'Repel Plus', brand: 'Shaw', finish: 'Natural', image: ds('10967', '102032409') }
  ],
  'area-rugs': [
    { name: 'Wind River', brand: 'Mohawk', finish: 'White', image: ds('11226', '300076716') },
    { name: 'Fable', brand: 'Shaw', finish: 'Metal', image: ds('94', '300082541') },
    { name: 'Optico', brand: 'Mohawk', finish: 'Forest Green', image: ds('10987', '102059494') },
    { name: 'Linaje', brand: 'Shaw', finish: 'Gray, Black & Gold', image: ds('10987', '102059488') },
    { name: 'Pacha', brand: 'Karastan (Mohawk)', finish: 'Burgundy', image: ds('11302', '300078661') }
  ]
};

